import type { GameMeta } from '@gmp/game-sdk';

export const plotTwistMeta = {
  id: 'plot-twist',
  name: 'Plot Twist',
  tagline: 'One absurd story, three acts, and everybody secretly steering it somewhere else.',
  description:
    'Together you write one ridiculous film in three acts: setup, escalation, finale. Each scene, everyone either pitches a line of their own or backs one of three event cards, then votes for the next canonical scene. You each have a secret objective ("the story ends at sea", "a llama appears in two acts"), and before the finale you predict how it all ends. At the premiere the whole story is revealed, with who forced which twists and whose objectives came true. Play in one sitting or over a few days.',
  minPlayers: 3,
  maxPlayers: 10,
  estimatedMinutes: [12, 25],
  usesMedia: false,
  modes: [{ id: 'story', name: 'Three acts', description: 'One shared story: 3, 4 or 6 scenes across setup, escalation and finale.' }],
  theme: { primary: '#f2c14e', secondary: '#d1495b', background: '#120f17', ink: '#f6efe2' },
  readiness: 'beta',
  genre: 'Storytelling with secret objectives',
  controls: 'tap',
  category: 'async',
  asyncInfo: {
    turnSeconds: [30, 90],
    match: { quick: '12–25 min', daily: '6–12 days' },
    difficulty: 'easy',
    tags: ['funny', 'creative', 'social'],
  },
  instructions: [
    { icon: 'Target', title: 'Get a secret objective', body: 'Everyone gets a private goal for the story, like "the story ends at sea" or "a robot appears in every act". Nobody else knows yours.' },
    { icon: 'PenLine', title: 'Pitch or back a card', body: 'Each scene, write a short continuation with its story tags, or back one of three event cards. Everyone plays at the same time, at their own pace.' },
    { icon: 'Vote', title: 'Vote for the next scene', body: 'Vote for one scene (not your own). Most votes wins; ties go to most backers, then player-written scenes, then the lowest ballot number. Votes stay secret until the premiere.' },
    { icon: 'Clapperboard', title: 'Predict the ending, then the premiere', body: 'Before the finale, predict how it ends. At the premiere: +5 for an objective you helped happen, +3 for the right ending, and points for votes your scenes earned (capped at 8).' },
  ],
} satisfies GameMeta;
